import React, { useState, useEffect } from "react";
import { Calendar, Views } from "react-big-calendar";
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
import { withRouter } from "react-router-dom";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import i18next from "i18next";
import "moment/min/locales";
import moment from "moment";

const DragAndDropCalendar = withDragAndDrop(Calendar);
const t = i18next.t.bind(i18next);

const Dnd = (props) => {
    const [events, setEvents] = useState(props.events);
    const [draggedEvent, setDraggedEvent] = useState(null);

    useEffect(() => {
        setEvents([...props.events]);
    }, [props]);
    const HandleDragStart = (event) => {
        console.log("handleDragStart");
        setDraggedEvent(event);
    };

    // takvimde "more" kısmında yer alan eventler için
    const OnDropFromOutside = ({ start, end }) => {
        console.log("onDropFromOutside");
        const event = {
            id: draggedEvent != null ? draggedEvent.id : null,
            title: draggedEvent != null ? draggedEvent.title : null,
            start,
            end,
            fromChild: true,
        };
        setDraggedEvent(null);
        let startDate = draggedEvent.start;
        MoveEvent({ event, startDate, start });
    };

    const MoveEvent = ({ event, startDate, start }) => {
        console.log("moveEvent");

        const nextEvents = events.map((existingEvent) => {
            return existingEvent.id === event.id ? { ...existingEvent, startDate, start } : existingEvent;
        });

        setEvents(nextEvents);
        props.onEventMoved(event, startDate, start);
    };

    const formats = {
        eventTimeRangeFormat: () => {
            return "";
        },
    };

    return (
        <DragAndDropCalendar
            formats={formats}
            //dayLayoutAlgorithm={"no-overlap"}
            //step={4}
            resizable
            timeslots={16}
            showMultiDayTimes={true}
            selectable
            localizer={props.localizer}
            events={events}
            culture={i18next.language}
            onEventDrop={MoveEvent}
            defaultView={Views.MONTH}
            view={props.view}
            defaultDate={props.defaultDate}
            style={{ height: (window.innerHeight)*(0.86), width: "99%", margin: 3 }}
            slotPropGetter={(date) => ({
                className: 'slotDefault',
                ...(moment(date).hour() < 8 && {
                  style: {
                    backgroundColor: 'aliceblue',
                    color: 'green',
                  },
                }),
                ...(moment(date).hour() >= 8 && {
                    style: {
                      backgroundColor: '#EAF2E8',
                      color: 'green',
                    },
                  }),
                ...(moment(date).hour() >= 16 && {
                  style: {
                    backgroundColor: 'rgb(198,218,214)',
                    color: 'green',
                  },
                }),
              })}
            popup={true}
            onDropFromOutside={OnDropFromOutside}
            handleDragStart={HandleDragStart}
            onSelectEvent={(event) => props.onClick(event.id)}
            onNavigate={props.onNavigate}
            onView={props.onView}
            eventPropGetter={(event, start, end, isSelected) => ({
                event,
                start,
                end,
                isSelected,
                style: { backgroundColor: event.color },
            })}
            messages={{
                week: t("Week"),
                day: t("Day"),
                month: t("Month"),
                previous: t("Previous"),
                next: t("Next"),
                today: t("Today"),
                agenda: t("Agenda"),
            }}
        />
    );
};

export default withRouter(Dnd);
